// extracted by mini-css-extract-plugin
export default {"setupChecklistButton":"OnboardingProtectionPlans_setupChecklistButton__pedih"};